export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-500"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
              移动追番，随时随地
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-[560px]">
              51动漫官网全面适配移动端浏览器，无需下载 App 即可在手机上流畅体验51动漫在线观看和51动漫下载功能。下拉式追更模式在手机上操作更自然，让您随时随地追最新动漫全集。
            </p>
          </div>
          <a
            href="#cards"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('cards')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex-shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-compass-line text-lg"></i>
            立即体验
          </a>
        </div>
      </div>
    </section>
  );
}